var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIomonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 683,
    viewBox: "0 0 683 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4578_116117)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4578_116117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 683,
    height: 683
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00134277H682.667V682.668H0V0.00134277Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4578_116117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.666 664.836H448.001C576.031 620.623 667.999 499.059 667.999 356C667.999 175.587 521.746 29.3332 341.333 29.3332C160.921 29.3332 14.666 175.587 14.666 356C14.666 499.059 106.635 620.623 234.666 664.836Z",
    fill: "#B197E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 546.668H234.667V664.837C268.097 676.381 303.978 682.668 341.333 682.668C378.688 682.668 414.569 676.381 448 664.837V546.668Z",
    fill: "#BEC8F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.667 664.835C260.061 673.603 286.871 679.331 314.667 681.578V546.666H234.667V664.835Z",
    fill: "#A2B6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.334 560H181.333C159.243 560 141.333 542.091 141.333 520V466.667H541.334V520C541.334 542.091 523.424 560 501.334 560Z",
    fill: "#D3DCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.667 520V466.667H141.333V520C141.333 542.091 159.243 560 181.333 560H294.667C272.576 560 254.667 542.091 254.667 520Z",
    fill: "#BEC8F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.333 -1.43051e-05H141.333C111.879 -1.43051e-05 88 23.8773 88 53.3333V426.667C88 456.123 111.879 480 141.333 480H541.333C570.788 480 594.667 456.123 594.667 426.667V53.3333C594.667 23.8773 570.788 -1.43051e-05 541.333 -1.43051e-05Z",
    fill: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.333 426.667V53.3333C201.333 23.8773 225.212 -1.43051e-05 254.667 -1.43051e-05H141.333C111.879 -1.43051e-05 88 23.8773 88 53.3333V426.667C88 456.123 111.879 480 141.333 480H254.667C225.212 480 201.333 456.123 201.333 426.667Z",
    fill: "#D3DCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.333 40.0026H141.333C133.981 40.0026 128 45.984 128 53.336V270.953L135.235 280.003L128 290.953V360.003C128 367.355 133.981 373.336 141.333 373.336H541.333C548.685 373.336 554.667 367.355 554.667 360.003V53.336C554.667 45.984 548.685 40.0026 541.333 40.0026Z",
    fill: "#47477F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.333 40.0026C133.981 40.0026 128 45.984 128 53.336V270.953L135.235 280.003L128 290.953V360.003C128 367.355 133.981 373.336 141.333 373.336H232.097V40.0026H141.333Z",
    fill: "#3B3868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.014 270.953H350.217L334.362 223.5C332.998 219.415 329.174 216.669 324.88 216.669C324.82 216.669 324.757 216.669 324.696 216.671C320.326 216.752 316.515 219.657 315.283 223.849L292.748 300.523L284.84 277.681C283.445 273.653 279.652 270.953 275.39 270.953H242.826L226.972 223.5C225.589 219.357 221.706 216.627 217.305 216.671C212.936 216.752 209.125 219.657 207.893 223.849L185.357 300.523L177.45 277.681C176.056 273.653 172.262 270.953 168 270.953H128V290.953H160.88L176.686 336.608C178.109 340.717 182.057 343.383 186.373 343.333C190.721 343.231 194.504 340.328 195.73 336.156L218.098 260.053L226.14 284.123C227.502 288.203 231.322 290.953 235.625 290.953H268.269L284.076 336.608C285.473 340.643 289.272 343.336 293.524 343.336C293.604 343.336 293.683 343.335 293.763 343.333C298.111 343.231 301.894 340.328 303.121 336.156L325.489 260.053L333.53 284.123C334.893 288.203 338.712 290.953 343.014 290.953H383.014C388.537 290.953 393.014 286.477 393.014 280.953C393.014 275.429 388.537 270.953 383.014 270.953Z",
    fill: "#89E56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.208 280H510.208",
    stroke: "#8AE1FF",
    strokeWidth: 20,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.208 240H510.208",
    stroke: "#8AE1FF",
    strokeWidth: 20,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.208 200H510.208",
    stroke: "#8AE1FF",
    strokeWidth: 20,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.208 320H510.208",
    stroke: "#8AE1FF",
    strokeWidth: 20,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.098 120.003C192.098 127.365 186.128 133.336 178.764 133.336C171.4 133.336 165.431 127.365 165.431 120.003C165.431 112.64 171.4 106.669 178.764 106.669C186.128 106.669 192.098 112.64 192.098 120.003Z",
    fill: "#FF4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.431 120.003C245.431 127.365 239.461 133.336 232.097 133.336C224.733 133.336 218.764 127.365 218.764 120.003C218.764 112.64 224.733 106.669 232.097 106.669C239.461 106.669 245.431 112.64 245.431 120.003Z",
    fill: "#FF7186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.764 120.003C298.764 127.365 292.795 133.336 285.431 133.336C278.067 133.336 272.098 127.365 272.098 120.003C272.098 112.64 278.067 106.669 285.431 106.669C292.795 106.669 298.764 112.64 298.764 120.003Z",
    fill: "#FF7186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.333 421.336C181.333 432.381 172.379 441.336 161.333 441.336C150.288 441.336 141.333 432.381 141.333 421.336C141.333 410.291 150.288 401.336 161.333 401.336C172.379 401.336 181.333 410.291 181.333 421.336Z",
    fill: "#FF4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.333 421.336C161.333 413.937 165.361 407.492 171.333 404.033C168.389 402.328 164.98 401.336 161.333 401.336C150.288 401.336 141.333 410.291 141.333 421.336C141.333 432.381 150.288 441.336 161.333 441.336C164.98 441.336 168.389 440.344 171.333 438.639C165.361 435.18 161.333 428.735 161.333 421.336Z",
    fill: "#E80054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.333 421.336C261.333 432.381 252.379 441.336 241.333 441.336C230.288 441.336 221.333 432.381 221.333 421.336C221.333 410.291 230.288 401.336 241.333 401.336C252.379 401.336 261.333 410.291 261.333 421.336Z",
    fill: "#FFDD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.333 421.336C341.333 432.381 332.379 441.336 321.333 441.336C310.288 441.336 301.333 432.381 301.333 421.336C301.333 410.291 310.288 401.336 321.333 401.336C332.379 401.336 341.333 410.291 341.333 421.336Z",
    fill: "#89E56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.333 421.336C541.333 432.381 532.379 441.336 521.333 441.336C510.288 441.336 501.333 432.381 501.333 421.336C501.333 410.291 510.288 401.336 521.333 401.336C532.379 401.336 541.333 410.291 541.333 421.336Z",
    fill: "#8AE1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.333 421.336C241.333 413.937 245.361 407.492 251.333 404.033C248.389 402.328 244.98 401.336 241.333 401.336C230.288 401.336 221.333 410.291 221.333 421.336C221.333 432.381 230.288 441.336 241.333 441.336C244.98 441.336 248.389 440.344 251.333 438.639C245.361 435.18 241.333 428.735 241.333 421.336Z",
    fill: "#FFC839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.333 421.336C321.333 413.937 325.361 407.492 331.333 404.033C328.389 402.328 324.98 401.336 321.333 401.336C310.288 401.336 301.333 410.291 301.333 421.336C301.333 432.381 310.288 441.336 321.333 441.336C324.98 441.336 328.389 440.344 331.333 438.639C325.361 435.18 321.333 428.735 321.333 421.336Z",
    fill: "#65D33C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.333 421.336C521.333 413.937 525.361 407.492 531.333 404.033C528.389 402.328 524.98 401.336 521.333 401.336C510.288 401.336 501.333 410.291 501.333 421.336C501.333 432.381 510.288 441.336 521.333 441.336C524.98 441.336 528.389 440.344 531.333 438.639C525.361 435.18 521.333 428.735 521.333 421.336Z",
    fill: "#42C3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.333 520C501.333 531.045 492.379 540 481.333 540C470.288 540 461.333 531.045 461.333 520C461.333 508.955 470.288 500 481.333 500C492.379 500 501.333 508.955 501.333 520Z",
    fill: "#BEC8F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.333 520C481.333 512.601 485.361 506.156 491.333 502.697C488.389 500.992 484.98 500 481.333 500C470.288 500 461.333 508.955 461.333 520C461.333 531.045 470.288 540 481.333 540C484.98 540 488.389 539.008 491.333 537.303C485.361 533.844 481.333 527.399 481.333 520Z",
    fill: "#A2B6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.333 533.336H194.667C187.303 533.336 181.333 527.365 181.333 520.003C181.333 512.64 187.303 506.669 194.667 506.669H381.333C388.697 506.669 394.667 512.64 394.667 520.003C394.667 527.365 388.697 533.336 381.333 533.336Z",
    fill: "#BEC8F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.667 506.669H194.667C187.303 506.669 181.333 512.639 181.333 520.003C181.333 527.367 187.303 533.336 194.667 533.336H256.952C255.476 529.164 254.667 524.68 254.667 520.003V506.669Z",
    fill: "#A2B6F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4578_116117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682.667,
    height: 682.667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIomonitoring);
export default __webpack_public_path__ + "static/media/io monitoring.92b776d5a3038fbed32e9319b8e35359.svg";
export { ForwardRef as ReactComponent };